const EditNewEnergy = () => import('../modules/xmsb/energy/operators/EditNewEnergyGzl')

export default [
  {

    path: '/energyedit',
    name: 'energyedit',
    component: EditNewEnergy,
    meta: {
      title: '新能源申报编辑',
      fullscreen: true,
    },
  },
]
